import { httpsCallable, functions } from '@/lib/functions';
import { networkMonitor } from '@/services/networkMonitor';
import { Platform } from 'react-native';

export type EntitlementSnapshot = {
  isPremium: boolean;
  planTier: 'free' | 'premium';
  subscriptionStatus: string;
  entitlementProvider: string;
  entitlementExpiresAt: string | null;
};

export const isExternalCheckoutAllowed = (): boolean => Platform.OS === 'web';

export async function refreshEntitlementState(): Promise<EntitlementSnapshot> {
  if (networkMonitor.shouldUseOfflineDataFallback()) {
    throw new Error('You are offline. Reconnect to refresh subscription status.');
  }
  const callable = httpsCallable<void, EntitlementSnapshot>(functions, 'refreshEntitlementState');
  const result = await callable();
  return result.data;
}

export async function createStripeCheckoutSession(interval: "monthly" | "annual" = "monthly") {
  if (networkMonitor.shouldUseOfflineDataFallback()) {
    throw new Error('You are offline. Reconnect to open checkout.');
  }
  if (!isExternalCheckoutAllowed()) {
    throw new Error('External web checkout is only available on web. Use in-app subscriptions on mobile.');
  }
  const callable = httpsCallable<
    { interval: "monthly" | "annual" },
    { url: string; sessionId: string }
  >(functions, "createStripeCheckoutSession");

  const result = await callable({ interval });
  return result.data;
}
